import React from 'react';
import { Redirect } from 'react-router-dom';
// 
import LoginPage from 'pages/Login';
import PasswordForgot from 'pages/PasswordForgot'
import PasswordReset from 'pages/PasswordReset'
// 
import {
  ROUTE_AUTH,
  ROUTE_AUTH_LOGIN,
  ROUTE_AUTH_FORGOT_PASS,
  ROUTE_AUTH_RESET_PASS
} from 'fixtures/routes';

// list of Auth child routes
const routes = [
  {
    path: '/',
    exact: true,
    main: () => <Redirect to={`/${ROUTE_AUTH}/${ROUTE_AUTH_LOGIN}`} />,
  },
  {
    path: `/${ROUTE_AUTH_LOGIN}`,
    exact: true,
    main: () => <LoginPage />
  },
  {
    path: `/${ROUTE_AUTH_FORGOT_PASS}`,
    exact: true,
    main: () => <PasswordForgot />
  },
  {
    path: `/${ROUTE_AUTH_RESET_PASS}`,
    exact: true,
    main: () => <PasswordReset />
  }
]

export default routes;
